import React from 'react';
import { AdditionalBookingOptionEntity } from 'Models/Entities';
import { tripDirectionTypes } from 'Models/Enums';
import { AddOnInputCounterWrapper } from 'Views/Components/AddOnsInputCounter/AddOnInputCounterWrapper';
import { AddOnOptionCard } from 'Views/Components/AddOns/AddOnOptionCard';
import If from 'Views/Components/If/If';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';
import { BookingAddOn } from '../../BookingWizardData/BookingAddOn';
import { useBookingWizardDataStore } from '../../BookingWizardDataStore';
import { isNotNullOrUndefined } from 'Util/TypeGuards';
import { AddOnCapacityRestrictionDto } from 'Services/Api/_HumanWritten/BookingWizardDataService';

export interface NewAddOnOptionProps {
	addOn: AdditionalBookingOptionEntity;
	/**
	 * Used as reference to see all options within section.
	 */
	sectionAddOns: AdditionalBookingOptionEntity[];
	maxSectionAddOnPerBooking?: number;
	departureCapacityRestriction?: AddOnCapacityRestrictionDto;
	returnCapacityRestriction?: AddOnCapacityRestrictionDto;
	sectionDisabled?: boolean;
}

export function AddOnOption({
	addOn,
	sectionAddOns,
	maxSectionAddOnPerBooking,
	departureCapacityRestriction,
	returnCapacityRestriction,
	sectionDisabled,
}: NewAddOnOptionProps) {
	const { wizardData } = useBookingWizardDataStore();

	return (
		<AddOnOptionCard
			name={addOn.name}
			iconName={addOn.iconName ?? undefined}
			colour={addOn.colour}
			staticPrice={addOn.staticPrice}
			information={addOn.information}
			removable={addOn.removable}
			removalTitle={addOn.removalTitle}
			removalInformation={addOn.removalInformation}
			displayInfoInTooltip={addOn.displayInfoInTooltip}
		>
			<div className={`add-on__input-counter-container ${wizardData.tripType}`}>
				<AddOnInputCounterWrapper
					addOn={addOn}
					direction="DEPARTURE"
					maxSectionAddOnPerBooking={maxSectionAddOnPerBooking}
					sectionAddOns={sectionAddOns}
					capacityRestriction={departureCapacityRestriction}
					sectionDisabled={sectionDisabled}
				/>
				<If condition={wizardData.tripType === 'return' && isNotNullOrUndefined(wizardData.returningJourney)}>
					<AddOnInputCounterWrapper
						addOn={addOn}
						direction="RETURN"
						maxSectionAddOnPerBooking={maxSectionAddOnPerBooking}
						sectionAddOns={sectionAddOns}
						capacityRestriction={returnCapacityRestriction}
						sectionDisabled={sectionDisabled}
					/>
				</If>
			</div>
		</AddOnOptionCard>
	);
}

export function getWizardDataAddOns(wizardData: BookingWizardData, direction: tripDirectionTypes): BookingAddOn[] {
	if (direction === 'DEPARTURE') {
		return wizardData.innerWizardData.departingTripOptions;
	}
	return wizardData.innerWizardData.returningTripOptions;
}
